// extracted by mini-css-extract-plugin
export default {"divBtn":"Button_divBtn__tnWjL","btn":"Button_btn__RBtNK","loader":"Button_loader__S3BdI","spin":"Button_spin__6FyKA"};